var map = {
	"./ae-gif-1.gif": 160,
	"./ae-gif-2.gif": 161,
	"./ae-gif-3.gif": 162,
	"./ae-gif-4.gif": 108,
	"./ae-gif-5.gif": 163,
	"./ae-gif-6.gif": 164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 159;